import { useTranslation } from "react-i18next";
import { getPublicationStatus } from "@/lib/publicationHelpers";
import { cn } from "@/lib/utils";
import type { Bien } from "@/types/bien";

/**
 * Mini-cellule pour la liste Suivi publication : 1 SEULE pastille globale
 * (3 états — non publié / publié / modifs non poussées) au lieu d'1 par
 * portail.
 *
 * Décision produit 2026-05-07 : l'utilisateur ne veut pas distinguer par
 * portail dans l'UI. Cohérence avec PublicationGlobalStatus dans la fiche
 * bien — même helper `getPublicationStatus()`, mêmes 3 couleurs, même
 * vocabulaire. Le point orange signale au survol qu'il y a des modifs à
 * pousser.
 */
export function PortalsCellMini({ bien }: { bien: Bien }) {
  const { t } = useTranslation();
  const status = getPublicationStatus(bien);

  const tooltip =
    status === "stale"
      ? t("portals.globalStatus.stale")
      : status === "publie"
        ? t("portals.globalStatus.publie")
        : t("portals.globalStatus.nonPublie");

  return (
    <span
      title={tooltip}
      className={cn(
        "w-2.5 h-2.5 rounded-full inline-block transition-colors",
        status === "publie" && "bg-success",
        status === "stale" && "bg-warning animate-pulse",
        status === "non-publie" && "bg-text-muted/30",
      )}
    />
  );
}
